module.exports = __webpack_public_path__ + "static/img/dz02.398a49ab.png";